import React, { useEffect, useState } from 'react';
import {
  Grid,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  Table,
  Paper,
  TableContainer,
  MenuItem,
  TablePagination,
  Select,
  // InputLabel,
  FormControl,
  Button,
  Stack,
  Typography,
  Alert,
  Snackbar,
  CircularProgress,
  Backdrop,
  Chip
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import AddSurrender from './AddSurrender';
// import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { FiBankListM, SurrenderMandateList, SurrenderMandateListApprove } from 'API/Mandate_Surrender';
import { LoadingButton } from '@mui/lab';

const Surrender = () => {
  const [bank, setBank] = useState('');
  const [BankList, setBankList] = useState([]);
  const [TotalCount, setTotalCount] = useState('');

  const [SurrenderRequest, setSurrenderRequest] = useState(false);
  const [Success, setSuccess] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [IsloadingBank, setIsloadingBank] = useState(false);
  const [SuccessMsg, setSuccessMsg] = useState(false);
  const [IsLoadingStatus, setIsLoadingStatus] = useState(false);
  const [Error, setError] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    // setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };
  const formattedName = (value) => {
    if (!value) return ''; // Handle null or undefined values

    // Convert to lowercase and capitalize the first letter of each word
    return value
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const handleApprove = (id) => {
    SurrenderMandateListApprove(id, setIsLoadingStatus, setSuccessMsg, setError, refunction);
  };

  const userType = sessionStorage.getItem('UserType');
  useEffect(() => {
    FiBankListM(setIsloadingBank, setBankList);
  }, []);

  const refunction = () => {
    setSuccess([]);
    SurrenderMandateList(page + 1, rowsPerPage, setIsloading, setSuccess, setError, setTotalCount, bank);
  };

  useEffect(() => {
    setSuccess([]);
    SurrenderMandateList(page + 1, rowsPerPage, setIsloading, setSuccess, setError, setTotalCount, bank);
  }, [page, rowsPerPage, bank]);

  return (
    <>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Grid item xl={12} width="100%">
        <SubCard
          title="Surrender"
          sx={{
            // marginTop: '20px',
            width: '100%',
            overflow: 'scroll',
            '&::-webkit-scrollbar': {
              width: '8px',
              height: '8px'
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '8px'
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555'
            }
          }}
        >
          {!SurrenderRequest ? (
            <>
              <Grid container spacing={2} alignItems="center" justifyContent="space-between" mb={2}>
                {/* Bank Selection */}
                <Grid item xs={6} sm={4} md={5} lg={4}>
                  <FormControl fullWidth variant="outlined">
                    {/* <InputLabel>Select Bank</InputLabel> */}
                    <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                      Select Bank
                    </Typography>
                    <Select value={bank} onChange={(e) => setBank(e.target.value)}>
                      <MenuItem value={'select'} disabled>
                        Select
                      </MenuItem>
                      {BankList && BankList.length > 0 ? (
                        BankList?.map((bank, index) => (
                          <MenuItem value={bank.Bankname} key={index}>
                            {bank.Full_Bank_Name.toUpperCase()}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem sx={{ pointerEvents: 'none', display: 'flex', justifyContent: 'center' }}>No bank data found</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={4} mt={3}>
                  <Button
                    onClick={() => {
                      setBank('');
                      refunction();
                    }}
                    sx={{
                      backgroundColor: '#592375',
                      color: '#FFFFFF',
                      borderRadius: '6px',
                      '&:hover': {
                        backgroundColor: '#592375'
                      }
                    }}
                    color="secondary"
                    disabled={!bank}
                    variant="contained"
                  >
                    clear
                  </Button>
                </Grid>
                {/* Create Surrender Request Button */}
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={5}
                  lg={4}
                  display="flex"
                  justifyContent="flex-end"
                  visibility={userType === 'sales_head' ? 'hidden' : 'inital'}
                >
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: '#688B2A',
                      color: '#FFFFFF',
                      borderRadius: '6px',
                      '&:hover': {
                        backgroundColor: '#688B2A'
                      }
                    }}
                    color="secondary"
                    onClick={() => setSurrenderRequest(true)}
                    endIcon={<AddCircleIcon />}
                  >
                    Create Surrender Request
                  </Button>
                </Grid>
              </Grid>
              <Paper sx={{ width: '70%' }}>
                <TableContainer
                  sx={{
                    maxHeight: 1000,
                    width: 1190,
                    '&::-webkit-scrollbar': {
                      width: '8px',
                      height: '8px'
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1'
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#888',
                      borderRadius: '8px'
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555'
                    }
                  }}
                >
                  {Success && Success.length ? (
                    <Table stickyHeader aria-label="sticky table" size="small">
                      <TableHead>
                        <TableRow>
                          {/* <TableCell sx={{ width: '10%' }}>S.No</TableCell> */}
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Bank Name</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Mandate ID</TableCell>
                          {/* {userType === 'sales_head' && */}
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Total Mandate</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Mandate Completed</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>In Pending</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>To be Surrender</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Penality(per mandate)</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Expiry Date</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Status</TableCell>
                          {userType === 'sales_head' && <TableCell sx={{ width: '10%', color: '#592375' }}>Action</TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Success &&
                          Success.map((row, index) => (
                            <React.Fragment key={index}>
                              <TableRow hover role="checkbox" tabIndex={-1} sx={{ cursor: 'pointer' }}>
                                {/* <TableCell sx={{ width: '10%' }}>1</TableCell> */}
                                <TableCell sx={{ width: '10%' }}>{row.product}</TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.mandate_id}</TableCell>
                                {/* {userType === 'sales_head' && */}
                                <TableCell sx={{ width: '10%' }}>{row.total_bcs_vacancy}</TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.total_completed}</TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.total_in_progress}</TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.total_pending}</TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.product}</TableCell>
                                {/* <TableCell sx={{ width: '10%' }}>{(row.total_bcs_vacancy-row.total_completed)-row.total_bcs_vacancy}</TableCell> */}
                                <TableCell sx={{ width: '10%' }}>{row.expiry_date || '-'}</TableCell>
                                <TableCell sx={{ width: '10%' }}>
                                  <Chip
                                    label={formattedName(row.status)}
                                    size="small"
                                    color={row.status === 'approved' ? 'success' : row.status === 'pending' ? 'warning' : 'default'}
                                  />
                                </TableCell>
                                {userType === 'sales_head' && (
                                  <TableCell sx={{ width: '10%' }}>
                                    <LoadingButton
                                      loading={IsLoadingStatus}
                                      size="small"
                                      variant={row.status === 'approved' ? 'contained' : 'outlined'}
                                      color={row.status === 'approved' ? 'success' : 'primary'}
                                      onClick={() => {
                                        if (row.status === 'pending') {
                                          handleApprove(row.mandate_id);
                                        }
                                      }}
                                    >
                                      {row.status === 'approved' ? 'Approved' : 'Approve'}
                                    </LoadingButton>
                                  </TableCell>
                                )}
                              </TableRow>
                            </React.Fragment>
                          ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <Stack justifyContent="center" alignItems="center">
                      <Typography mt={5} mb={3} variant="h5">
                        No data found
                      </Typography>
                    </Stack>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={TotalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </Paper>
            </>
          ) : (
            <AddSurrender
              IsloadingBank={IsloadingBank}
              setSurrenderRequest={setSurrenderRequest}
              BankList={BankList}
              refunction={refunction}
            />
          )}
        </SubCard>
      </Grid>
    </>
  );
};

export default Surrender;
